import { render, staticRenderFns } from "./ResizableContainer.vue?vue&type=template&id=c5befeba"
import script from "./ResizableContainer.vue?vue&type=script&lang=js"
export * from "./ResizableContainer.vue?vue&type=script&lang=js"
import style0 from "./ResizableContainer.vue?vue&type=style&index=0&id=c5befeba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports